define(
    'MerchZone.View',
    [
        'CustomContentType.Base.View',
        'merchzone.tpl',
        'Utils',
        'jQuery',
        'underscore',
        'AddToCartModal.View',
    ],
    function (
        CustomContentTypeBaseView,
        template,
        Utils,
        jQuery,
        _,
        AddToCartModalView
    ) {
        'use strict';

        return CustomContentTypeBaseView.extend({
            template: template,

            /**@type {Settings}*/
            settings: null,

            initialize: function (options) {
                this._initialize();
                this.environment = options.container.getComponent("Environment");
                this.configuration = this.environment.getConfig();
                this.layout = options.container.getComponent("Layout");
                this.cart = options.container.getComponent("Cart");
                this.addingToCart = false;

                /* MerchZone Setup */
                this.on('afterViewRender', function () {
                    var merchRule = this.settings.custrecord_ttmerchzone_merchrule;

                    if (merchRule && merchRule !== '') {
                        this.fetchMerchZoneEndpoint(merchRule);
                    }
                });
            },

            events: {
                'click .tt-ext-merchzone-item-add-to-cart': 'addToCartEvent'
            },

            getItemData: function (internalid) {
                for (var i = 0; i < this.items.length; i++) {
                    if (this.items[i].id.toString() === internalid) {
                        return this.items[i];
                    }
                }
            },

            addToCartEvent: function (e) {
                var self = this;
                var internalid = e.currentTarget.getAttribute("data-id");

                if (self.addingToCart === false) {
                    self.addingToCart = true;

                    this.cart.addLine({
                        line: {
                            quantity: 1,
                            item: {
                                internalid: internalid
                            }
                        }
                    }).then(function () {
                        var modalView = new AddToCartModalView({
                            item: self.getItemData(internalid)
                        });

                        if (self.layout) {
                            self.layout.showContent(modalView,
                                {
                                    showInModal: true,
                                    options: {
                                        className: 'tt-ext-merchzone-modal'
                                    }
                                }
                            );

                            self.addingToCart = false;
                        }
                    });
                }
            },

            showPrice: function showPrice() {
                return this.settings.custrecord_ttmerchzone_price === "T" && !this.logInToSeePrice();
            },

            showSku: function showSku() {
                return this.settings.custrecord_ttmerchzone_sku === "T";
            },

            showRating: function getRating() {
                return this.settings.custrecord_ttmerchzone_reviews === "T";
            },

            showSeeMore: function showSeeMore() {
                /* The index of 'See More' button is 2 */
                return this.settings.custrecord_ttmerchzone_buttonaction === "2";
            },

            showAddToCart: function showAddToCart() {
                /* The index of 'Add To Cart' button is 1 */
                return (this.settings.custrecord_ttmerchzone_buttonaction === "1") && !this.logInToSeePrice();
            },

            getButtonStyle: function getButtonStyle() {
                var buttonStyle = "primary";

                switch (this.settings.custrecord_ttmerchzone_buttonstyle) {
                    case "1": buttonStyle = "primary"; break;
                    case "2": buttonStyle = "secondary"; break;
                    case "3": buttonStyle = "tertiary"; break;
                    case "4": buttonStyle = "quaternary"; break;
                    case "5": buttonStyle = "link"; break;
                }

                return buttonStyle;
            },

            showArrows: function showArrows() {
                /* Pager and Arrows:	1 */
                /* Only Arrows:			3 */
                /* Only Bottom Arrows:	4 */
                return this.settings.custrecord_ttmerchzone_controltype === "1" || this.settings.custrecord_ttmerchzone_controltype === "3" || this.settings.custrecord_ttmerchzone_controltype === "4";
            },

            showPager: function showPager() {
                /* Pager and Arrows:	1 */
                /* Only Pager:			2 */
                return this.settings.custrecord_ttmerchzone_controltype === "1" || this.settings.custrecord_ttmerchzone_controltype === "2";
            },

            getBorderType: function getBorderType() {
                /* None:	    1 */
                /* Item Cell:   2 */
                /* Item Image:  3 */
                switch (this.settings.custrecord_ttmerchzone_bordertype) {
                    case "2":
                        return "tt-ext-merchzone-border-cell";
                        break;
                    case "3":
                        return "tt-ext-merchzone-border-image";
                        break;
                    default:
                        return "";
                        break;
                }
            },

            /**
             * Log in to see price validation
             */
            logInToSeePrice: function logInToSeePrice() {
                var getRegistrationType = function () {
                    /* registrationmandatory is 'T' when customer registration is disabled */
                    if (this.environment.getSiteSetting('registration.registrationmandatory') === 'T') {
                        /* no login, no register, checkout as guest only */
                        return 'disabled';
                    }

                    else {
                        if (this.environment.getSiteSetting('registration.registrationoptional') === 'T') {
                            /* login, register, guest */
                            return 'optional';
                        }
                        else {
                            if (this.environment.getSiteSetting('registration.registrationallowed') === 'T') {
                                /* login, register, no guest */
                                return 'required';
                            }
                            else {
                                /* login, no register, no guest */
                                return 'existing';
                            }
                        }
                    }
                };

                /* We've got to disable loginToSeePrices feature if customer registration is disabled. */
                return getRegistrationType !== 'disabled' &&
                    this.environment.getSiteSetting('requireloginforpricing', 'F') === 'T' &&
                    this.environment.getSiteSetting('is_logged_in') !== true;
            },

            getDefaultImage: function getDefaultImage(itemimages) {
                /**
                 * Flatten method taken from SCA Utils
                 * @param {Object} images
                 * @returns {ItemImage[]}
                 */
                function flattenImages(images) {
                    if ('url' in images && 'altimagetext' in images) {
                        return [images];
                    }

                    return _.flatten(
                        _.map(images, function (item) {
                            if (_.isArray(item)) {
                                return item;
                            }
                            return flattenImages(item);
                        })
                    );
                };

                var imageData = flattenImages(itemimages);

                var defaultImage = _.find(imageData, function (image) {
                    var match = image.url.match(/.*\.default\.[A-Za-z]*/i);
                    return !!match && match[0] === image.url;
                });

                return defaultImage || imageData[0];
            },

            getCustomImage: function getCustomImage(item) {
                var customImageUrl = !!this.configuration.tavanoTeamSmartMerchZone.customFields.image.url ? item[this.configuration.tavanoTeamSmartMerchZone.customFields.image.url] : false;
                var customImageAlt = !!this.configuration.tavanoTeamSmartMerchZone.customFields.image.altText ? item[this.configuration.tavanoTeamSmartMerchZone.customFields.image.altText] : "";

                if (!!customImageUrl) {
                    return {
                        url: customImageUrl,
                        altimagetext: customImageAlt
                    };
                } else {
                    return false;
                }
            },

            getControlsStyles: function getControlsStyles() {
                var controlsColor = this.settings.custrecord_ttmerchzone_controlscolor;

                switch (controlsColor) {
                    case "2": controlsColor = 'dark'; break;
                    case "3": controlsColor = 'light'; break;
                    default: controlsColor = 'default';
                }

                var classes = "tt-ext-merchzone-controls-style-" + controlsColor;
                classes += this.showArrows() ? " tt-ext-merchzone-controls-arrows" : "";
                classes += this.settings.custrecord_ttmerchzone_controlsshadow === "T" ? " tt-ext-merchzone-controls-style-shadows" : "";
                classes += this.settings.custrecord_ttmerchzone_controltype === "4" ? " tt-ext-merchzone-bottom-arrows" : "";

                return classes;
            },

            getItemsDevicesDisplay: function getItemsDevicesDisplay(itemsCount) {
                var xsCount = this.settings.custrecord_ttmerchzone_itemdisplayxs || "1";
                var smCount = this.settings.custrecord_ttmerchzone_itemdisplaysm || "2";
                var mdCount = this.settings.custrecord_ttmerchzone_itemdisplaymd || "3";
                var lgCount = this.settings.custrecord_ttmerchzone_itemdisplaylg || "4";
                var xlCount = this.settings.custrecord_ttmerchzone_itemdisplayxl || "4";
                
                var classes = "";

                classes += itemsCount < parseInt(xsCount) ? " tt-ext-merchzone-items-xs-" + itemsCount : " tt-ext-merchzone-items-xs-" + xsCount;
                classes += itemsCount < parseInt(smCount) ? " tt-ext-merchzone-items-sm-" + itemsCount : " tt-ext-merchzone-items-sm-" + smCount;
                classes += itemsCount < parseInt(mdCount) ? " tt-ext-merchzone-items-md-" + itemsCount : " tt-ext-merchzone-items-md-" + mdCount;
                classes += itemsCount < parseInt(lgCount) ? " tt-ext-merchzone-items-lg-" + itemsCount : " tt-ext-merchzone-items-lg-" + lgCount;
                classes += itemsCount < parseInt(xlCount) ? " tt-ext-merchzone-items-xl-" + itemsCount : " tt-ext-merchzone-items-xl-" + xlCount;

                classes += " tt-ext-merchzone-items-count-" + itemsCount;

                return classes;
            },

            /**
             * Fetch merchzone information from SMT CMS endpoint
             * @param {string | number} merchzoneId Merchzone ID to fetch
             */
            fetchMerchZoneEndpoint: function fetchMerchZoneEndpoint(merchzoneId) {
                jQuery.ajax({
                    url: '/api/cms/v2/merchzones/' + merchzoneId,
                }).done(
                    function (res) {
                        this.fetchItems(res.data[0].queryString);
                    }.bind(this)
                );
            },

            /**
             * Fetch items from items enddpoint returned from merchzone endpoint
             * @param {string} itemsEndpoint
             */
            fetchItems: function fetchItems(itemsEndpoint) {
                jQuery.ajax({
                    url: itemsEndpoint,
                }).done(
                    function (res) {
                        var itemDetails = _.map(
                            res.items,
                            function (item) {
                                /** @type {Item} */

                                var customName = this.configuration.tavanoTeamSmartMerchZone.customFields.name != "" ? item[this.configuration.tavanoTeamSmartMerchZone.customFields.name] || false : false;

                                var isMatrix = item.itemoptions_detail.matrixtype === "parent";

                                /* old price */
                                var oldPrice = '';

                                if (this.configuration.priceLevel.enabled && !!this.configuration.priceLevel.default) {
                                    if (!!item[this.configuration.priceLevel.default + "_formatted"]) {
                                        if (item[this.configuration.priceLevel.default + "_formatted"] != item.onlinecustomerprice_formatted) {
                                            oldPrice = item[this.configuration.priceLevel.default + "_formatted"];
                                        }
                                    }
                                }

                                var formattedItem = {
                                    isinstock: item.isinstock,
                                    ispurchasable: item.ispurchasable,
                                    id: item.internalid, /* for 'Add To Cart' button */
                                    sku: item.itemid,
                                    isMatrix: isMatrix,
                                    name: customName || item.storedisplayname || item.storedisplayname2 || item.displayname,
                                    price: {
                                        unformatted: item.onlinecustomerprice,
                                        formatted: item.onlinecustomerprice_formatted,
                                        matrix: !!item.onlinematrixpricerange ? item.onlinematrixpricerange : false,
                                        old: oldPrice,
                                        shopperCurrency: this.environment.getSiteSetting().shopperCurrency.code
                                    },
                                    rating: this.showRating() && item.hasOwnProperty('custitem_ns_pr_rating') ? (item.custitem_ns_pr_rating || 0) : false,
                                    link: '/' + item.urlcomponent,
                                    image: this.getCustomImage(item) || this.getDefaultImage(item.itemimages_detail)
                                };

                                return formattedItem;

                            }.bind(this)
                        );

                        this.items = itemDetails;

                        this.renderMerchzone(itemDetails);

                    }.bind(this)
                );
            },

            /**
             * Render item info to template
             * @param {Item[]} items
             */
            renderMerchzone: function renderMerchzone(items) {
                if (items.length === 0) {
                    return;
                }

                _.each(
                    items,
                    function (item) {

                        /* Clone Template */
                        var template = this.$('#tt-ext-merchzone-item-template').contents().clone();

                        /* Links */
                        template.find('[data-tt-ext-merchzone="link"]').attr('href', item.link);

                        /* Images: No Image Available checker */
                        if (typeof item.image === "undefined") {
                            item.image = {
                                url: Utils.getThemeAbsoluteUrlOfNonManagedResources('img/no_image_available.jpeg', this.configuration.imageNotAvailable),
                                altimagetext: item.name
                            };
                        }

                        /* Images: Resize Image */
                        item.image.url = Utils.resizeImage(this.configuration.siteSettings.imagesizes || [], item.image.url, 'thumbnail');

                        /* Images: Lazy Loading checker */
                        if (typeof lazySizes != 'undefined') {
                            template.find('[data-tt-ext-merchzone="image"]').addClass('lazyload');
                            template.find('[data-tt-ext-merchzone="image"]').attr('data-src', item.image.url);
                        } else {
                            template.find('[data-tt-ext-merchzone="image"]').attr('src', item.image.url);
                        }

                        template.find('[data-tt-ext-merchzone="image"]').attr('alt', (item.image.altimagetext || item.name));

                        /* Name */
                        template.find('[data-tt-ext-merchzone="name"]').text(item.name);

                        /* Sku */
                        if (this.showSku()) {
                            if (!!item.sku) {
                                template.find('[data-tt-ext-merchzone="sku-value"]').text(item.sku);
                            } else {
                                template.find('[data-tt-ext-merchzone="sku"]').remove();
                            }
                        }

                        /* Price */
                        if (this.showPrice() && !!item.price && item.ispurchasable) { /* 'item.isinstock' is not necessary for the moment */
                            /* Matrix Price */
                            if (!!item.price.matrix) {
                                var matrixPrices = item.price.matrix.split(' ');

                                if (matrixPrices[0] != matrixPrices[1]) {
                                    template.find('[itemprop="lowPrice"]').text(Utils.formatCurrency(matrixPrices[0]));
                                    template.find('[itemprop="lowPrice"]').attr('data-rate', matrixPrices[0]);
                                    template.find('[itemprop="highPrice"]').text(Utils.formatCurrency(matrixPrices[1]));
                                    template.find('[itemprop="highPrice"]').attr('data-rate', matrixPrices[1]);

                                    /* Remove Lead Price */
                                    template.find('[data-tt-ext-merchzone="price-lead"]').remove();
                                } else {
                                    /* Low and High Prices are equal, set lead price instead */
                                    item.price.matrix = false;
                                }
                            }

                            /* Lead Price */
                            if (!!item.price.matrix === false) {
                                template.find('[data-tt-ext-merchzone="price-lead"]').text(item.price.formatted);
                                template.find('[data-tt-ext-merchzone="price-lead"]').attr('data-rate', item.price.unformatted);

                                /* Remove Range Price */
                                template.find('[data-tt-ext-merchzone="price-range"]').remove();
                            }

                            /* Old Price */
                            if (!!item.price.old && (item.price.formatted != item.price.old)) {
                                template.find('[data-tt-ext-merchzone="price-old"]').text(item.price.old);
                            } else {
                                /* Remove Old Price */
                                template.find('[data-tt-ext-merchzone="price-old"]').remove();
                            }

                            /* Price availability for 'schema.org' */
                            var availability = 'https://schema.org/OutOfStock';

                            if (item.ispurchasable) {
                                if (item.isinstock) {
                                    availability = 'https://schema.org/InStock';
                                } else {
                                    if (this.configuration.structureddatamarkup.availabilityonbackorder === 'PreOrder') {
                                        availability = 'https://schema.org/PreOrder';
                                    } else {
                                        availability = 'https://schema.org/InStock';
                                    }
                                }
                            }

                            template.find('[itemprop="availability"]').attr('href', availability);

                            /* Set the price meta content */
                            template.find('meta[itemprop="priceCurrency"]').attr('content', item.price.shopperCurrency);
                        } else {
                            /* Remove Price */
                            template.find('[data-tt-ext-merchzone="price"]').remove();
                        }

                        /* Rating */
                        if (this.showRating()) {
                            template.find('[data-tt-ext-merchzone="rating-fill"]').attr('style', 'width:' + ((parseFloat(item.rating) * 100) / 5) + '%;');
                            template.find('[data-tt-ext-merchzone="rating"] [data-value]').attr('data-value', item.rating);
                            template.find('[data-tt-ext-merchzone="rating"] [itemprop="ratingValue"]').attr('content', item.rating);
                        }

                        /* 'Add To Cart' & 'Choose Options' Buttons */
                        if (this.showAddToCart() && item.ispurchasable) { /* 'item.isinstock' is not necessary for the moment */
                            if (!item.isMatrix) {
                                /* 'Add To Cart' Button */
                                template.find('[data-tt-ext-merchzone="add-to-cart"]').attr('data-id', item.id);
                                template.find('[data-tt-ext-merchzone="add-to-cart"]').addClass('button-' + this.getButtonStyle());

                                /* Remove 'Choose Options' Button */
                                template.find('[data-tt-ext-merchzone="choose-options"]').remove();
                            } else {
                                /* 'Choose Options' Button */
                                template.find('[data-tt-ext-merchzone="choose-options"]').attr('href', item.link);
                                template.find('[data-tt-ext-merchzone="choose-options"]').addClass('button-' + this.getButtonStyle());

                                /* Remove 'Add To Cart' Button */
                                template.find('[data-tt-ext-merchzone="add-to-cart"]').remove();
                            }
                        } else {
                            /* Remove 'Add To Cart' & 'Choose Options' Buttons */
                            template.find('[data-tt-ext-merchzone="add-to-cart"]').remove();
                            template.find('[data-tt-ext-merchzone="choose-options"]').remove();
                        }

                        /* 'See More' Button */
                        if (this.showSeeMore()) {
                            template.find('[data-tt-ext-merchzone="see-more"]').attr('href', item.link);
                            template.find('[data-tt-ext-merchzone="see-more"]').addClass('button-' + this.getButtonStyle());
                        } else {
                            /* Remove 'See More' button */
                            template.find('[data-tt-ext-merchzone="see-more"]').remove();
                        }

                        /* Add Template */
                        this.$('.tt-ext-merchzone-items-wrapper').append(template);
                    },
                    this
                );

                /* Items To Display */
                this.$('.tt-ext-merchzone-items-container').addClass(this.getItemsDevicesDisplay(items.length));

                /* Render Carousel */
                if (this.settings.custrecord_ttmerchzone_iscarousel === 'T') {
                    this.renderCarousel();
                }
            },

            renderCarousel: function renderCarousel() {
                var carouselOptions = {
                    auto: this.settings.custrecord_ttmerchzone_autoslide && this.settings.custrecord_ttmerchzone_autoslide === "T",
                    pause: parseInt(this.settings.custrecord_ttmerchzone_autoslidetime || 5000),
                    infiniteLoop: this.settings.custrecord_ttmerchzone_infiniteloop === "T",
                    hideControlOnEnd: this.settings.custrecord_ttmerchzone_infiniteloop != "T",
                    randomStart: this.settings.custrecord_ttmerchzone_randomstart === "T",
                    adaptiveHeight: true,
                    minSlides: 1,
                    maxSlides: parseInt(this.settings.custrecord_ttmerchzone_itemdisplayxl || 4),
                    slideWidth: 300,
                    touchEnabled: true,
                    swipeThreshold: 100,
                    oneToOneTouch: true,
                    preventDefaultSwipeX: true,
                    preventDefaultSwipeY: false,
                    stopAutoOnClick: true,
                    autoHover: true,
                    moveSlides: this.settings.custrecord_ttmerchzone_moveone === "T" ? 1 : 0,
                    pager: this.showPager(),
                    controls: this.showArrows(),
                    nextText: '<a class="tt-ext-merchzone-next-icon"></a>',
                    prevText: '<a class="tt-ext-merchzone-prev-icon"></a>'
                };

                Utils.initBxSlider(this.$('.tt-ext-merchzone-items-wrapper'), carouselOptions);
            },

            contextDataRequest: [],

            validateContextDataRequest: function validateContextDataRequest() {
                return true;
            },

            getContext: function () {
                return {
                    container: this.settings.custrecord_ttmerchzone_contentcontainer === "T" ? "container" : "container-fluid",
                    title: this.settings.custrecord_ttmerchzone_title,
                    grid: {
                        enable: this.settings.custrecord_ttmerchzone_iscarousel != "T",
                        classes: (this.settings.custrecord_ttmerchzone_gridcenter === "T" ? " tt-ext-merchzone-center-items" : "")
                    },
                    carousel: {
                        enable: this.settings.custrecord_ttmerchzone_iscarousel === "T",
                        classes: this.getControlsStyles()
                    },
                    showRating: this.showRating(),
                    showSku: this.showSku(),
                    seeMoreButton: this.showSeeMore(),
                    logInToSeePrice: this.logInToSeePrice(),
                    showPrice: this.showPrice(),
                    addToCartButton: this.showAddToCart(),
                    borderType: this.getBorderType(),
                };
            },
        });
    });
